export default __webpack_public_path__ + "static/media/raft.82ea2192.svg";